//Generated File 
export default class OverrideSelectedDimension{
	static readonly Always = `Always`;
	static readonly Never = `Never`;
	static readonly WhenNotPublic = `WhenNotPublic`;
}
